export var getLastListItemCount = function (components, index) {
    var allowedTypes = ['image', 'video', 'iframe', 'text', 'code', 'informative'];
    var isCompText = function (comp) { return comp.type === 'text'; };
    var getEndingLiInOlInHtml = function (html) {
        var dummy = document.createElement('div');
        dummy.innerHTML = html;
        var last = dummy.lastElementChild;
        if (last && last.tagName === 'OL') {
            return last.children.length;
        }
        return 0;
    };
    if (index === 0) {
        return 0;
    }
    var lastComp = components[index - 1];
    if (lastComp && isCompText(lastComp)) {
        var countLi = getEndingLiInOlInHtml(lastComp.value.html);
        return countLi ? countLi + getLastListItemCount(components, index - 1) : 0;
    }
    else if (lastComp && allowedTypes.indexOf(lastComp.type) !== -1) {
        return getEndingLiInOlInHtml(lastComp.value.html) + getLastListItemCount(components, index - 1);
    }
    else {
        return 0;
    }
};
//# sourceMappingURL=index.js.map